<template>
    <AppHead title="Members" />
    <div class="px-4 md:px-8 py-8 w-full max-w-9xl mx-auto" data-page="members">
        <Members></Members>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import AppHead from '@/Partials/AppHead.vue';
import Members from '@/components/members/index.vue';

const userData = computed(() => usePage().props.userData);
</script>
